import { createContext, useContext, useEffect, useRef } from "react";
import Lenis from "lenis";

export const LenisContext = createContext({ lenisRef: { current: null }, scrollTo: () => {} });

export const useLenisScroll = () => useContext(LenisContext);

export function useLenis() {
    const lenisRef = useRef(null);

    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        lenisRef.current = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            lenisRef.current = null;
        };
    }, []);

    const scrollTo = (target, opts = {}) => {
        if (lenisRef.current) {
            lenisRef.current.scrollTo(target, { offset: -72, duration: 1.2, ...opts });
        } else if (typeof target === "number") {
            window.scrollTo(0, target);
        } else {
            const el = typeof target === "string" ? document.querySelector(target) : target;
            el?.scrollIntoView({ behavior: "smooth" });
        }
    };

    return { lenisRef, scrollTo };
}
